import { useSelector } from 'react-redux'

import SelectDateTimePage from 'components/select_date_time'
import { ReconfirmationPage } from 'components/confirmation'
import { schedulingLinkSelector } from 'selectors/event_type'
import { LandingPagePage } from 'components/landing_page'
import { RoutingFormPage } from 'components/routing_form'

import { SchedulingLinkContainer } from './container'

export const SchedulingLinkPage = () => {
  const { owner_type: ownerType } = useSelector(schedulingLinkSelector)
  switch (ownerType) {
    case 'Share':
      return <SelectDateTimePage />
    case 'InviteeConfirmation':
      return <ReconfirmationPage />
    case 'LandingPage':
      return (
        <SchedulingLinkContainer expanded>
          <LandingPagePage />
        </SchedulingLinkContainer>
      )
    case 'FormBuilder::Form':
      return (
        <SchedulingLinkContainer expanded>
          <RoutingFormPage />
        </SchedulingLinkContainer>
      )
    default:
  }
  return null
}
